import { useMemo } from 'react';
import { UseFormReturn, FieldValues } from 'react-hook-form';
import { DateRange } from 'react-day-picker';

/**
 * Derives a DateRange from a form's start_datetime and end_datetime fields.
 * Keeps the dateRange in sync as the user changes dates.
 */
export function useFormDateRange(
  form: UseFormReturn<FieldValues>,
): DateRange | undefined {
  const startDatetime = form.watch('start_datetime') as Date | undefined;
  const endDatetime = form.watch('end_datetime') as Date | undefined;

  return useMemo(
    () =>
      startDatetime && endDatetime
        ? { from: startDatetime, to: endDatetime }
        : undefined,
    [startDatetime, endDatetime],
  );
}
